import { render, staticRenderFns } from "./tab-waiting.vue?vue&type=template&id=3316b112&scoped=true"
import script from "./tab-waiting.vue?vue&type=script&lang=js"
export * from "./tab-waiting.vue?vue&type=script&lang=js"
import style0 from "./tab-waiting.vue?vue&type=style&index=0&id=3316b112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3316b112",
  null
  
)

export default component.exports